import { Box, Card, Typography, Button, Container } from "@material-ui/core";
import { Phone as PhoneIcon } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import {
  SUPPORT_CENTER_PHONE_NUMBER,
  SUPPORT_CENTER_PHONE_NUMBER_TEL_URL
} from "../logic/Consts";

export default function FeatureBlockedNotice() {
  const { t } = useTranslation();

  return (
    <Container maxWidth="sm" sx={{ py: 6 }}>
      <Card sx={{ p: 4, textAlign: "center" }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          {t("paidUserGate.title")}
        </Typography>
        <Typography variant="body1" sx={{ mb: 4, color: "text.secondary" }}>
          {t("paidUserGate.description")}
        </Typography>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            variant="contained"
            color="primary"
            size="large"
            startIcon={<PhoneIcon />}
            href={SUPPORT_CENTER_PHONE_NUMBER_TEL_URL}
          >
            {t("paidUserGate.callCta", { phone: SUPPORT_CENTER_PHONE_NUMBER })}
          </Button>
        </Box>
      </Card>
    </Container>
  );
}
